var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudgetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "budget-icon_svg__h-5 budget-icon_svg__w-5",
    viewBox: "-2 -3 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 2.625h-12.5a.625.625 0 010-1.25H13a.625.625 0 100-1.25H2.375A1.883 1.883 0 00.5 2v10a1.883 1.883 0 001.875 1.875h12.5a1.25 1.25 0 001.25-1.25v-8.75a1.25 1.25 0 00-1.25-1.25zm-2.813 6.563a.937.937 0 110-1.875.937.937 0 010 1.875z",
    fill: "#33647E"
  })));
}
export default SvgBudgetIcon;